
const lang ={
   
};

export default lang;